import React from 'react';
import {observable, action, runInAction} from 'mobx';
import {observer} from 'mobx-react';
import { CatCard } from './comps/card/card';
import { CircularProgress, Button } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Header } from './comps/header/header';

const LIMIT = 30;

type Props = {

};

type State = {

}

@observer
export class Main extends React.Component<Props, State> {
  @observable cats: string[] = [];
  @observable loading: boolean = false;

  componentDidMount() {
    this.fetchCats();
  }

  @action
  fetchCats = async () => {
    this.loading = true;
    const resp = await fetch(`https://api.thecatapi.com/v1/images/search?size=med&limit=${LIMIT}`);
    const body = await resp.json();
    runInAction(() => {
      this.cats = [...this.cats, ...body.map((img: any) => img.url)];
      this.loading = false;
    });
  }

  RefreshButton = () => {
    return (
      <Button
      variant="contained"
      color="primary"
      size="large"
      onClick={this.fetchCats}
      startIcon={<RefreshIcon />}
    >
      Load more
    </Button>
    )
  }

  render() {
    const {RefreshButton} = this;
    return (<div>
      <Header />
      {this.cats.map((url, idx) => <CatCard key={idx} url={url}></CatCard>)}
      {this.loading ? <CircularProgress /> : <RefreshButton />}
    </div>)
  }
}
